// Components==============
import newsIndex from 'actions/news/index';
import Layout from 'components/Layout';
import Button from 'components/UI/Button';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import NewsCard from './components/NewsCard';
import NewsCardModal from './components/NewsCardModal';
import './index.module.scss';
// =========================

export default function News() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(newsIndex());
    }, []);

    const news = useSelector((state) =>
        state?.news?.entities?.allIds
            ?.map((id) => state?.news?.entities?.byId[id])
            ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    );

    const { pathname } = useLocation();
    const urlId = pathname?.split('/')?.[3];
    const activeModal = news?.find((t) => urlId === `${t.id}`);

    console.log(urlId);

    const [loadMore, setLoadMore] = useState(6);

    // format date
    const formattedDate = (date) => {
        const d = new Date(date);
        const month = d.toLocaleString('nl-NL', { month: 'long' });
        const day = d.getDate();
        const year = d.getFullYear();
        return `${day} ${month} ${year}`;
    };

    return (
        <Layout>
            <Container>
                <HeroLayout>
                    <div styleName="wrapper">
                        {news.map(
                            (item, i) =>
                                i <= loadMore - 1 && (
                                    <NewsCard
                                        key={i}
                                        image={item.image}
                                        created_at={formattedDate(
                                            item.created_at
                                        )}
                                        title={item.title}
                                        content={item.content}
                                        id={item.id}
                                    />
                                )
                        )}
                    </div>
                    {loadMore >= news?.length - 1 ? null : (
                        <div styleName="btn">
                            <Button
                                onClick={() => setLoadMore(loadMore + 6)}
                                background="#fff"
                                color="#1E265C"
                            >
                                Meer laden
                            </Button>
                        </div>
                    )}
                    <NewsCardModal news={activeModal} />
                </HeroLayout>
            </Container>
        </Layout>
    );
}
